import React from "react";
import "./Loader.css";

const Loader = () => {
	return (
		<div className="loader-mark-wrap" role="status" aria-label="Pagina laadt">
			<img
				src={require("../images/V-2.png")}
				alt=""
				className="loader-mark"
				aria-hidden="true"
			/>
			<div className="loader-rule" aria-hidden="true"></div>
		</div>
	);
};

export default Loader;
